import { defineComponent as _defineComponent } from 'vue';
import Button from "@/components/ui/button/Button.vue";
import Dropdown from "@/components/ui/dropdown/Dropdown.vue";
import { ChevronDownIcon, SearchIcon } from "lucide-vue-next";
import { computed } from "vue";
import { useTableZoom } from "../use-table-zoom";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TableZoomDropdown',
    setup(__props, { expose: __expose }) {
        __expose();
        const { tableZoom, setZoom, zoomLevels } = useTableZoom();
        const currentLabel = computed(() => { var _a, _b; return (_b = (_a = zoomLevels.find((l) => l.value === tableZoom.value)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : "100%"; });
        function select(value, close) {
            setZoom(value);
            close();
        }
        const __returned__ = { tableZoom, setZoom, zoomLevels, currentLabel, select, Button, Dropdown, get ChevronDownIcon() { return ChevronDownIcon; }, get SearchIcon() { return SearchIcon; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
